import LoginRepository from 'client-sdk/src/Repository/login-repository';
import {takeLatest, put} from 'redux-saga/effects';
import {
  LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  VERIFY_OPT,
  VERIFY_OPT_SUCCESS,
  VERIFY_OPT_FAILED,
  GENERATE_OPT,
  GENERATE_OPT_SUCCESS,
  GENERATE_OPT_FAILED,
} from './constants';
import {Actions} from './interfaces';
import handleNotfication from '../../utils/handleNotfication.tsx';
import {handleRedirectByRule} from '../../utils/helpers';

export function* authentication(action: Actions): any {
  try {
    var response = yield LoginRepository.authentication(action);
    if (
      response.data.role == 'PARTNER_ADMIN' ||
      response.data.role == 'CENTER_ADMIN' ||
      response.data.role == 'AGENCY_ADMIN' ||
      response.data.role == 'SELLER_ADMIN'
    ) {
      var vitrin = yield LoginRepository.getPartnerVitrin({
        token: response.data?.token,
      });
      yield put({
        type: LOGIN_SUCCESS,
        data: {...response.data, vitrin: vitrin.data},
      });
      window.location.pathname !== '/login'
        ? window.location.reload()
        : handleRedirectByRule(response.data.role);
    } else {
      yield put({
        type: LOGIN_FAILED,
        error: 'not-for-this',
      });
    }
  } catch (error) {
    if (error.config.url === '/partners/has-access') {
      yield put({
        type: LOGIN_SUCCESS,
        data: response.data,
      });
      window.location.pathname !== '/login'
        ? window.location.reload()
        : handleRedirectByRule(response.data.role);
    } else {
      yield put({
        type: LOGIN_FAILED,
        error: error.message,
      });
    }
  }
}

export function* generateOpt(action: any): any {
  const {callback} = action.payload;
  try {
    const response = yield LoginRepository.generateOpt(action);
    yield put({
      type: GENERATE_OPT_SUCCESS,
      data: response.data,
    });
    callback();
  } catch (error) {
    yield put({
      type: GENERATE_OPT_FAILED,
      error: error.message,
    });
  }
}

export function* verifyOpt(action: any): any {
  try {
    const response = yield LoginRepository.verifyOpt(action);
    yield put({
      type: VERIFY_OPT_SUCCESS,
      data: response.data,
    });
    handleNotfication('ورود با موفقیت انجام شد', 'success');
    window.location.pathname !== '/login'
      ? window.location.reload()
      : (window.location.href = '/orders');
  } catch (error) {
    yield put({
      type: VERIFY_OPT_FAILED,
      error: error.message,
    });
  }
}

export default function* loginSaga() {
  yield takeLatest(LOGIN, authentication);
  yield takeLatest(VERIFY_OPT, verifyOpt);
  yield takeLatest(GENERATE_OPT, generateOpt);
}
